import {
  ArrowLeftRegularIcon,
  ArrowRightFromBracketRegularIcon,
} from "@elixir/icons";
import React from "react";
import { LinkButton, PrimaryButton, SecondaryButton } from "ui";
import ExitFlowPopup from "./exit-flow-popup";

type TVerifyFlowContainerProps = {
  title: string;
  children: React.ReactNode;
  secondaryButtonText?: string | null;
  primaryButtonText: string;
  secondaryButtonClick?: () => void;
  primaryButtonClick: () => void;
  primaryButtonLoading: boolean;
};

const VerifyFlowContainer = ({
  title,
  secondaryButtonClick,
  secondaryButtonText,
  primaryButtonClick,
  primaryButtonText,
  primaryButtonLoading,
  children,
}: TVerifyFlowContainerProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  return (
    <>
      <div className="dr-w-full dr-relative">
        <div className="md:dr-w-1/2 dr-w-full dr-px-16 dr-py-40 md:dr-p-48 dr-space-y-24">
          <div className="Title2Bold dr-text-darwin-touch-neutral-1000">
            {title}
          </div>
          <div className="dr-space-y-16">
            {children}
            <div className="dr-flex dr-justify-between dr-items-center">
              {secondaryButtonText && secondaryButtonClick ? (
                <LinkButton
                  title={secondaryButtonText}
                  onClick={secondaryButtonClick}
                  IconComponent={() => (
                    <ArrowLeftRegularIcon className="dr-w-12 dr-h-12 dr-text-darwin-touch-primary-primary" />
                  )}
                  buttonIconPosition="left"
                />
              ) : (
                <div />
              )}
              <PrimaryButton
                width={200}
                title={primaryButtonText}
                onClick={primaryButtonClick}
                isLoading={primaryButtonLoading}
              />
            </div>
          </div>
        </div>
      </div>
      <ExitFlowPopup
        show={isModalOpen}
        closePopup={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default VerifyFlowContainer;
